export const enum SCENES_KEYS {
  BootScene = 'BootScene',
  ClubsMapScene = 'ClubsMapScene',
  MainMapScene = 'MainMapScene',
}
